import React, { useState, useEffect, useContext } from 'react';
import AppointmentForm from './AppointmentForm';
import Tippy from '@tippyjs/react';
import { SVGIcon } from '@superops/super-icons';
import { SkeletonBodyText, TextStyle } from '@superops/ui-design-system';
import SchedulingContext from '../Contexts/SchedulingContext';
import { CREATE_APPOINTMENT, TicketClient } from '@nile/graphql/src';
import { useMutation } from '@apollo/client';
import {
  ALL_MODULES,
  EventEmitter,
  toast,
  useActivityTracker
} from '@nile/components/src';
import { FormattedMessage } from 'react-intl';
import { useGlobalState } from '@nile/components/src/Managers/StateManager';
import AppointmentFloaterPortal from './AppointmentFloater';
import { isEmpty } from 'lodash';
import { loggerInfo } from '@nile/home/src/coralogixRUM';

const NewAppointment = (props) => {
  const tippyRef = React.useRef(null);
  const [showAppointmentForm, setShowAppointmentForm] = useState(true);
  const [saveLoading, setSaveLoading] = useState(false);
  const schedulingContext = useContext(SchedulingContext);
  const currentView = schedulingContext?.calendarView;
  const mixPanelEventSource =
    schedulingContext?.mixPanelEventSource || ALL_MODULES.scheduling;
  const dispatcherView = schedulingContext?.dispatcherView;

  function forceUpdate() {
    tippyRef?.current?._tippy?.popperInstance?.forceUpdate();
  }
  let timeout;

  useEffect(() => {
    // tippyRef.current._tippy.show();
    // if (timeout) {
    //   clearTimeout(timeout);
    // } else {
    //   timeout = setTimeout(() => {
    //     forceUpdate();
    //   }, 500);
    // }
  }, []);

  const getDispatcherEvents = (module) => {
    switch (module) {
      case ALL_MODULES.ticket:
        return 'Scheduled an event from Dispatch calendar through ticket';
      case ALL_MODULES.project:
        return 'Scheduled an event from Dispatch calendar through project';
      case ALL_MODULES.scheduling:
        return 'Scheduled an event from Dispatch calendar directly from the calendar view';
      default:
        return '';
    }
  };

  const getCalendarEvents = (module) => {
    switch (module) {
      case ALL_MODULES.ticket:
        return 'Scheduled an event from my calendar through ticket';
      case ALL_MODULES.project:
        return 'Scheduled an event from my calendar through project';
      case ALL_MODULES.scheduling:
        return 'Scheduled an event from my calendar directly from the calendar view';
      default:
        return '';
    }
  };

  const [createAppointment] = useMutation(CREATE_APPOINTMENT, {
    client: TicketClient,
    onCompleted() {
      EventEmitter.dispatch('refreshCalendar');
      let mixpanelEvent;
      if (dispatcherView) {
        mixpanelEvent = getDispatcherEvents(mixPanelEventSource);
      } else {
        mixpanelEvent = getCalendarEvents(mixPanelEventSource);
      }
      if (mixpanelEvent) {
        useActivityTracker({
          event: mixpanelEvent
        });
      }
    }
  });

  const onSave = (data) => {
    setSaveLoading(true);
    let organizer;

    if (data?.organizer?.user?.userId || data?.organizer?.id) {
      organizer = {
        userId: data?.organizer?.user?.userId || data?.organizer?.id
      };
    }
    const attendees = data?.attendees.map((el) => {
      if (isEmpty(organizer) || !organizer?.userId) {
        if (el?.attendeeType === 'ORGANIZER' && el?.userId) {
          organizer = {
            userId: el?.userId
          };
        }
      }

      return {
        acceptanceStatus: el?.acceptanceStatus,
        attendeeType: el?.attendeeType,
        user: {
          userId: el?.userId
        }
      };
    });

    const address = data?.address?.addressId
      ? {
          addressId: data?.address?.addressId
        }
      : null;

    const attachments = data?.attachments.map(
      ({ downloadURL, ...keepAttrs }) => ({ ...keepAttrs })
    );

    const formattedInput = {
      eventDuration: data?.eventDuration,
      workId: data?.workItem?.workId,
      organizer: organizer,
      subject: data?.subject,
      address: address,
      description: data?.description,
      addAttachments: attachments,
      addAttendees: attendees
    };

    if (!isEmpty(organizer) && !isEmpty(attendees)) {
      // if (
      //   isEmpty({
      //     userId: data?.organizer?.user?.userId || data?.organizer?.id
      //   }) &&
      //   window?.logger
      // ) {
      //   window?.logger?.info(
      //     'Appointment created but organizer is not available from form',
      //     {
      //       formData: data,
      //       variables: {
      //         input: formattedInput
      //       }
      //     }
      //   );
      //   window?.logger?.flush();
      // }

      if (
        isEmpty({
          userId: data?.organizer?.user?.userId || data?.organizer?.id
        })
      ) {
        loggerInfo(
          'Appointment created but organizer is not available from form',
          {
            formData: data,
            variables: {
              input: formattedInput
            }
          }
        );
      }

      createAppointment({
        variables: {
          input: formattedInput
        }
      })
        .then((res) => {})
        .catch(() => {
          setSaveLoading(false);
        });
    } else {
      if (window?.logger) {
        window?.logger?.info(
          'Unable to createAppointment as no organizer is present',
          {
            variables: {
              input: formattedInput
            }
          }
        );
        window?.logger?.flush();
      }
    }
  };

  // const [
  //   schedulingAppointmentFormData,
  //   setSchedulingAppointmentFormData
  // ] = useGlobalState('schedulingAppointmentFormData', {});

  // const onDataChange = (key, value, data) => {
  //   if ((key, value)) {
  //     const updatedData = { ...schedulingAppointmentFormData, [key]: value };
  //     setSchedulingAppointmentFormData(updatedData);
  //   }
  //   if (data) {
  //     const updatedData = {
  //       ...schedulingAppointmentFormData,
  //       ...data
  //     };
  //     setSchedulingAppointmentFormData(updatedData);
  //   }
  // };

  return (
    <>
      <div className="fhp">
        {saveLoading ? (
          <SkeletonBodyText lines={2} />
        ) : (
          <div id="New-Appointment" className="flex actr jctr fhp">
            <div className="flex actr g10">
              <div>
                <SVGIcon name="DatePicker" />
              </div>
              <div>
                <TextStyle weight="Medium">
                  <FormattedMessage id="scheduling.event.new.create" />
                </TextStyle>
              </div>
            </div>
          </div>
        )}
      </div>
      {showAppointmentForm && (
        <AppointmentFloaterPortal
          start={props?.event?.start}
          end={props?.event?.end}
          onCancel={props?.event?.onCancel}
          attendees={props?.event?.attendees}
          onSave={onSave}
          saveLoading={saveLoading}
          minDate={new Date(schedulingContext?.integratedDate)}
        />
      )}
    </>
  );
};

export default NewAppointment;
